import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as navActions from '~/sidebarNav/actions';
import LibraryViewSummaryBar from '~/library/containers/LibraryViewSummaryBar';
import LoaderWrapper from '~/components/LoaderWrapper';
type LibraryViewHeaderProps = {
  libraryState: object;
};
class LibraryViewHeader extends React.Component<LibraryViewHeaderProps, {}> {
  constructor(props, context) {
    super(props, context);
  }
  render() {
    const { libraryState } = this.props;
    const { component = {} } = libraryState;
    const { libraryModel = {} } = component;
    const { name: componentName = '' } = libraryModel;
    return (
      <div className="grid pt">
        <div className="grid__item col-1-1">
          <div className="bg-color--primary-dark bo-rad--top-5">
            <div className="grid ph">
              <div
                className="grid__item col-1-1"
                data-automation-id="LibraryViewHeader-Summary-Header"
              >
                <LoaderWrapper
                  isLoaderShowing={!componentName}
                  customLoader={<div className="color--white-dark pv-">Loading ...</div>}
                >
                  <h1 className="color--white font--20 font-family--body pv- mv-- antialiased phone--h4 phone--no-overflow">
                    {componentName} Vulnerability Data
                  </h1>
                </LoaderWrapper>
              </div>
            </div>
          </div>
          <LibraryViewSummaryBar libraryState={libraryState} />
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    libraryState: state.libraryState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(navActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LibraryViewHeader);
